import { React, useState } from 'react';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
import BadgeRoundedIcon from '@mui/icons-material/BadgeRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import GppGoodRoundedIcon from '@mui/icons-material/GppGoodRounded';
import PictureAsPdfRoundedIcon from '@mui/icons-material/PictureAsPdfRounded';
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';
import VerifiedRoundedIcon from '@mui/icons-material/VerifiedRounded';

import { Alerta } from '../../components/alerta';
import PageHeader from '../../components/pageHeader';
import SubmitButton from '../../components/submitButton';
import { fetchFlask } from '../../utils/fetchFlask';
import { maskCpfCnpj } from '../../utils/maskCpfCnpj';
import '../css/debtClearance.css';

const QuitacaoDebitos = () => {
    const [cpfCnpj, setCpfCnpj] = useState('');
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [openAlerta, setOpenAlerta] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    async function submitQuitacaoDebitos (e) {
        e.preventDefault();
        setIsSubmit(true);

        const body = JSON.stringify({
            cpfCnpj
        });

        try {
            const response = await fetchFlask('quitacaoDebitos', body);

            if (response.status === 'success') {
                setCpfCnpj('');
            }

            setMessage(response.message);
            setStatus(response.status);
            setOpenAlerta(true);
        } finally {
            setIsSubmit(false);
        }
    };

    const completedFields = [cpfCnpj].filter(Boolean).length;

    return (
        <Box className='mainBox debt-clearance-page'>
            <Alerta
                texto={message}
                status={status}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />
            <PageHeader>
                Declaração de Quitação de Débitos
            </PageHeader>

            <form action='' method='POST' id='formCadastrarCC' onSubmit={submitQuitacaoDebitos} className='debt-clearance-layout'>
                <Box className='debt-clearance-workspace'>
                    <Box className='debt-clearance-intro'>
                        <Box>
                            <h2>Certidão de nada consta para documento</h2>
                        </Box>
                        <p>
                            Informe o CPF ou CNPJ para gerar a declaração de quitação de débitos em PDF.
                        </p>
                    </Box>

                    <Box className='debt-clearance-panel'>
                        <Box className='debt-clearance-section-heading'>
                            <BadgeRoundedIcon />
                            <Box>
                                <span>Etapa 1</span>
                                <strong>Identificação do cliente</strong>
                            </Box>
                        </Box>

                        <Box className='debt-clearance-document-strip'>
                            <VerifiedRoundedIcon />
                            <TextField
                                required
                                label='CPF/CNPJ'
                                value={cpfCnpj}
                                inputProps={{ maxLength: 18 }}
                                onChange={(e) => setCpfCnpj(maskCpfCnpj(e.target.value))}
                            />
                        </Box>
                    </Box>

                    <Box className='debt-clearance-rail'>
                        <Box>
                            <GppGoodRoundedIcon />
                            <span>Documento</span>
                            <strong>Nada consta</strong>
                        </Box>
                        <Box>
                            <PictureAsPdfRoundedIcon />
                            <span>Formato</span>
                            <strong>PDF</strong>
                        </Box>
                    </Box>
                </Box>

                <Box className='debt-clearance-summary'>
                    <Box className='debt-clearance-summary-header'>
                        <FactCheckRoundedIcon />
                        <Box>
                            <span>Resumo</span>
                            <strong>Revisão da certidão</strong>
                        </Box>
                    </Box>

                    <Box className='debt-clearance-summary-list'>
                        <Box>
                            <span>CPF/CNPJ</span>
                            <strong className={!cpfCnpj ? 'is-empty' : undefined}>
                                {cpfCnpj || 'Não informado'}
                            </strong>
                        </Box>
                        <Box>
                            <span>Tipo</span>
                            <strong>Declaração de quitação de débitos</strong>
                        </Box>
                        <Box>
                            <span>Saída</span>
                            <strong>Documento assinado por e-mail</strong>
                        </Box>
                    </Box>

                    <Box className='debt-clearance-attention'>
                        <TaskAltRoundedIcon />
                        <p>
                            A certidão será emitida para o documento informado, atestando a inexistência de débitos conosco.
                        </p>
                    </Box>

                    <Box className='debt-clearance-completion'>
                        <AssignmentTurnedInRoundedIcon />
                        <Box>
                            <span>Campos críticos</span>
                            <strong>{completedFields}/1 preenchido</strong>
                        </Box>
                    </Box>

                    <SubmitButton isSubmit={isSubmit} startIcon={<PictureAsPdfRoundedIcon />}>
                        Solicitar Certidão
                    </SubmitButton>
                </Box>
            </form>
        </Box>
    );
};

export default QuitacaoDebitos;
